import { useNavigate, useLocation } from "react-router-dom";
import { PromoHeaderPill } from "./PromoHeaderPill";

// ---------------------------------------------------------------------------
// Shared header for every signed-out / public page (Home, Landing, Sign in,
// Sign up, Pricing, FAQ, About, Privacy, Disclaimer, Reset password). Keeps
// the 4 nav tabs (Plans, About, FAQ, Sign in) visible everywhere so visitors
// always have a way to jump between marketing pages.
//
// The active tab is highlighted based on the current path so users know
// where they are. On phones the secondary tabs (Plans/About/FAQ) collapse;
// the primary "Sign in" CTA is always visible.
// ---------------------------------------------------------------------------

const NAV_LINKS = [
  { label: "Practice Library", path: "/practices", testId: "public-nav-practices-btn" },
  { label: "Plans", path: "/pricing", testId: "public-nav-plans-btn" },
  { label: "About", path: "/about",   testId: "public-nav-about-btn" },
  { label: "FAQ",   path: "/faq",     testId: "public-nav-faq-btn" },
];

export const PublicHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Treat /sign-in and /login as the same tab for highlight purposes.
  const isSignInActive = ["/sign-in", "/login"].includes(location.pathname);

  return (
    <header
      className="px-6 sm:px-10 py-5 flex items-center justify-between max-w-[1440px] mx-auto"
      data-testid="public-header"
    >
      <button
        onClick={() => navigate("/")}
        className="flex items-center"
        aria-label="Bilateral Calm home"
        data-testid="public-nav-home-btn"
      >
        <img
          src="/logo-bilateral-calm.png"
          alt="Bilateral Calm"
          className="h-28 sm:h-32 w-auto"
        />
      </button>

      <nav className="flex items-center gap-1 sm:gap-2" aria-label="Primary">
        <PromoHeaderPill />
        {NAV_LINKS.map(({ label, path, testId }) => {
          const active = location.pathname === path;
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`hidden sm:inline-flex text-sm font-medium px-3 sm:px-4 py-2 rounded-full transition-colors ${
                active
                  ? "text-[#1B2349] bg-white/70"
                  : "text-[#4A5568] hover:text-[#1B2349] hover:bg-white/40"
              }`}
              aria-current={active ? "page" : undefined}
              data-testid={testId}
            >
              {label}
            </button>
          );
        })}
        <button
          onClick={() => navigate("/sign-in")}
          className={`ml-1 sm:ml-2 text-sm font-medium px-4 py-2 rounded-full transition-colors ${
            isSignInActive
              ? "bg-[#1B2349] text-white hover:bg-[#0F1838]"
              : "text-[#1B2349] hover:bg-white/60"
          }`}
          aria-current={isSignInActive ? "page" : undefined}
          data-testid="public-nav-signin-btn"
        >
          Sign in
        </button>
      </nav>
    </header>
  );
};

export default PublicHeader;
